/* Yotpo "(N Reviews" text rewrite. After the 2026-09-21 Yotpo-live-stars lane this
   file does exactly ONE thing and creates nothing: it rewrites any `.text-m` whose
   text contains "Review" (the replacement string is read from the script tag's
   data-replacement attribute — ")" everywhere except the reviews page, which passes
   ""). It never injects a star, so it can never be the reason a star row appears late.
   MutationObserver-driven; callbacks are coalesced onto one animation frame; it stops
   when the work is done, plus a grace window, with a hard cap.

   WHAT WAS DELETED AND WHY — the card path, `styleBottomlines()`.
   That function forced `display:flex; align-items:center` onto every
   `.yotpo-bottomline`. `.yotpo-bottomline` only ever existed because the Yotpo app
   embed hydrated the empty `<div class="yotpo bottomLine">` that
   snippets/card-product.liquid and snippets/product-listing-carousel.liquid used to
   emit for every product CARD, and the two declarations were a card-layout fix (the
   same pair main-collection-no-usf.liquid:36-37 documents). Rounds 6 and 7 stopped
   emitting that div on every card path, and the 2026-09-21 lane replaced what
   remained with `<div class="ystar">` slots filled by assets/yotpo-stars.js. So the
   function had no card left to fix.

   THE EVIDENCE, since "dead" is a claim and not an observation:
     * The theme emits ZERO `class="yotpo bottomLine"`, ZERO `.text-m` and ZERO
       `.yotpo-stars` nodes — a comment-aware scan of every .liquid file returns 0.
     * `yotpo-bottomline` appears in exactly one script this store ships, the LEGACY
       staticw2.yotpo.com widget.js (3 occurrences). The three modern
       cdn-widgetsrepository bundles — reviews-main-widget, reviews-star-ratings,
       reviews-seo-page — contain it ZERO times, as does app-standard.
     * That legacy widget.js is loaded from exactly ONE live place:
       templates/page.reviews.liquid:100. sections/footer.liquid:477 has the same
       loader but it is INSIDE A LIQUID COMMENT, so it does not ship — which is why
       "the legacy widget loads on every page" is false and was worth checking.

   WHY `rewrite()` STAYS. It is the function every remaining tag configures via
   `data-replacement`, and `/pages/reviews` — the one template that still loads the
   legacy widget — passes "". Yotpo delivers that widget's markup as server-rendered
   HTML over XHR rather than as a string inside its JS bundles, so a bundle grep can
   prove `.yotpo-bottomline` present but CANNOT prove `.text-m` absent. Keeping the
   one cheap, self-terminating rewrite is the conservative side of that uncertainty;
   deleting a function whose target is merely unproven is not.

   Remaining tag sites: sections/main-product.liquid:3520 (PDP),
   sections/after_pay_cart.liquid:208, sections/carousel_404.liquid:214,
   templates/page.artist.liquid:963, templates/page.reviews.liquid:120.
   The tag that this file's previous header listed at carousel_2.liquid:209 was
   already removed and the reference was stale.

   Window guard: first tag on the page wins. */
(function () {
  if (window.__yotpoReviewTextDone) return;
  window.__yotpoReviewTextDone = true;
  var tag = document.currentScript;
  var replacement = (tag && tag.getAttribute('data-replacement')) || '';

  /* Hard ceiling on observation. Chosen above the ~33s worst case the 2026-08-08
     audit measured for Yotpo injection on throttled mobile; the observer is idle
     (zero cost) whenever the DOM is idle, so the ceiling only bounds pathological
     pages that never stop mutating. */
  var HARD_CAP_MS = 60000;
  /* Yotpo fills cards progressively, so keep watching after the first clean pass. */
  var GRACE_MS = 5000;

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    var observer = null;
    var done = false;
    var scheduled = false;
    var graceTimer = null;
    var seenTextM = false;

    function rewrite() {
      var nodes = document.querySelectorAll('.text-m');
      /* Termination used to key on having SEEN a `.yotpo-bottomline`; with the card
         path gone, `.text-m` is the only target left, so it is the only honest
         completion signal. Without this the observer would idle to the hard cap on
         every page. */
      if (nodes.length) seenTextM = true;
      nodes.forEach(function (el) {
        var v = el.textContent;
        if (v.indexOf('Review') !== -1) {
          el.textContent = v.replace(' Review', replacement).replace('s', '');
        }
      });
    }

    function outstanding() {
      var left = 0;
      document.querySelectorAll('.text-m').forEach(function (el) {
        if (el.textContent.indexOf('Review') !== -1) left++;
      });
      return left;
    }

    function finish() {
      if (done) return;
      done = true;
      if (graceTimer) clearTimeout(graceTimer);
      if (observer) observer.disconnect();
    }

    function pass() {
      scheduled = false;
      if (done) return;
      rewrite();
      if (seenTextM && outstanding() === 0) {
        /* Work looks complete. Wait out the grace window in case more cards land;
           any further mutation reschedules a pass, which restarts the window. */
        if (graceTimer) clearTimeout(graceTimer);
        graceTimer = setTimeout(finish, GRACE_MS);
      } else if (graceTimer) {
        clearTimeout(graceTimer);
        graceTimer = null;
      }
    }

    function schedule() {
      if (scheduled || done) return;
      scheduled = true;
      if (window.requestAnimationFrame) window.requestAnimationFrame(pass);
      else setTimeout(pass, 16);
    }

    pass();

    if (window.MutationObserver) {
      observer = new MutationObserver(schedule);
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
      setTimeout(finish, HARD_CAP_MS);
    } else {
      /* No observer support: keep the legacy single late sweep rather than nothing. */
      setTimeout(function () {
        pass();
        finish();
      }, 6000);
    }
  });
})();
